<template>
    <div>
        <div class="common-level-rail">
            <el-button size="small" type="primary" @click="addFun">添加</el-button>
        </div>
        <div class="table-wrap">
            <el-table :data="listData" style="width: 100%" v-loading="loading">
                <el-table-column prop="role_id" label="ID" width="100"></el-table-column>
                <el-table-column prop="name" label="名称"></el-table-column>
                <el-table-column prop="type.name" label="类型" width="100" align="center">
                    <template slot-scope="scope" v-if="type[scope.row.type]">
                    {{ type[scope.row.type].name }}
                    </template>
                </el-table-column>
                <el-table-column prop="intro" label="说明"></el-table-column>
                <el-table-column prop="status" label="状态" width="60">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == 1" class="green">显示</span>
                        <span v-if="scope.row.status == 0" class="gray">隐藏</span>
                    </template>
                </el-table-column>
                <el-table-column prop="create_time" label="添加时间" width="120"></el-table-column>
                <el-table-column prop="name" label="操作" width="120">
                    <template slot-scope="scope">
                        <el-button @click="editFun(scope.row)" type="text" size="small">编辑</el-button>
                        <el-button @click="deleteFun(scope.row)" type="text" size="small">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!--分页-->
            <div class="pagination">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
                :page-sizes="[20, 50, 100, 200, 300, 500]"
                :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
                :total="totalDataNumber">
                </el-pagination>
            </div>
            <!--添加-->
            <Add v-if="open_add" :open_add="open_add" :type="type" @closeDialog="closeDialogFunc($event, 'add')"></Add>

            <!--编辑-->
            <Edit v-if="open_edit" :open_edit="open_edit" :type="type" :form="form" @closeDialog="closeDialogFunc($event, 'edit')"></Edit>

        </div>
    </div>
</template>

<script>
    import CodeRoleApi from '@/api/study/code_role.js';
    import Edit from './part/Edit.vue';
    import Add from './part/Add.vue';
    import {deepClone} from '@/utils/base.js';
    export default {
        components: {
            /*编辑组件*/
            Edit,
            Add
        },
        data() {
            return {
                /*一页多少条*/
                pageSize: 20,
                /*一共多少条数据*/
                totalDataNumber: 0,
                /*当前是第几页*/
                curPage: 1,
                /*分类*/
                listData: [],
                /*是否打开添加弹窗*/
                open_add: false,
                /*是否打开编辑弹窗*/
                open_edit: false,
                /*当前编辑的对象*/
                form: {},
                /*是否加载完成*/
                loading: true,
                type: [],
            }
        },
        created() {
            /*获取列表*/
            this.getTableList();
        },
        methods: {
            /*选择第几页*/
            handleCurrentChange(val) {
                let self = this;
                self.curPage = val;
                self.loading = true;
                self.getTableList();
            },

            /*每页多少条*/
            handleSizeChange(val) {
                this.curPage = 1;
                this.pageSize = val;
                this.getTableList();
            },
            /*获取列表*/
            getTableList() {
                let self = this;
                let Params = {};
                Params.page = self.curPage;
                Params.list_rows = self.pageSize;
                CodeRoleApi.getList(Params, true)
                .then(data =>
                    {
                        self.loading = false;
                        self.listData = data.data.list.data;
                        self.totalDataNumber = data.data.list.total;
                        self.type = data.data.type;
                    })
                    .catch(error =>
                    {
                      self.loading = false;
                    });
            },

            /*删除*/
            deleteFun(row) {
                let self = this;
                self.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() =>
                {
                    self.loading = true;
                    CodeRoleApi.del({
                        role_id: row.role_id
                    }, true)
                        .then(data =>
                        {
                            self.loading = false;
                            self.$message({
                                message: data.msg,
                                type: 'success'
                            });
                            self.getTableList();

                        })
                        .catch(error =>
                        {
                            self.loading = false;
                        });

                }).catch(() =>
                {

                });
            },

            /*打开添加*/
            addFun() {
                this.open_add = true;
            },

            /*打开编辑*/
            editFun(item) {
                this.form = deepClone(item);
                this.open_edit = true;
            },

            /*关闭弹窗*/
            closeDialogFunc(e, f) {
                if (f == 'add') {
                    this.open_add = e.openDialog;
                    if (e.type == 'success') {
                        this.getTableList();
                    }
                }
                if (f == 'edit') {
                    this.open_edit = e.openDialog;
                    if (e.type == 'success') {
                        this.getTableList();
                    }
                }
            },
        }
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/study/code/role/Index.vue